import React, { useState, useEffect } from "react";
import axios from "axios";
import { CircularProgressbar } from "react-circular-progressbar";
import { FiLock } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import "./Practice.css";
import "react-circular-progressbar/dist/styles.css";
import Sidebar from "../Components/Sidebar";

const Practice = () => {
  const [questionTypes, setQuestionTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const navigate = useNavigate();

  localStorage.setItem("PracticeID", null);

  useEffect(() => {
    const jwtToken = localStorage.getItem("jwtToken");

    if (!jwtToken) {
      console.error("JWT token not found");
      return;
    }

    axios
      .get(`${process.env.REACT_APP_API_URL}/question-types`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      })
      .then((response) => {
        setQuestionTypes(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching question types:", error);
        setLoading(false);
      });
  }, []);

  const handleClick = (item) => {
    if (!item.show) {
      setShowModal(true);
      return;
    }

    if (selectedTypes.includes(item.question_type_id)) {
      setSelectedTypes(
        selectedTypes.filter((id) => id !== item.question_type_id)
      );
    } else {
      setSelectedTypes([...selectedTypes, item.question_type_id]);
    }
  };

  const handleSubmit = async () => {
    const jwtToken = localStorage.getItem("jwtToken");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/questions/type`,
        { question_type_ids: selectedTypes },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );

      if (!response.data.error) {
        navigate("/practice-questions", {
          state: {
            questions: response.data.data.questions,
            wrongQuestions: response.data.data.wrong_questions,
          },
        });
        localStorage.setItem("PracticeID", response.data.data.practice_id);
      } else {
        alert("Error: " + response.data.msg);
      }
    } catch (err) {
      console.error(err);
      alert("An error occurred while fetching questions.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="overview">
      <Sidebar />
      <div className="practice-container">
        <div className="question-list">
          {questionTypes.map((item) => {
            const isSelected = selectedTypes.includes(item.question_type_id);
            const language = localStorage.getItem("lang") || "en";

            return (
              <div
                key={item.question_type_id}
                className={`question-item ${!item.show ? "locked" : ""} ${
                  isSelected ? "selected" : ""
                }`}
                onClick={() => handleClick(item)}
              >
                <div className="icon">
                  {item.show ? (
                    <img
                      src={item.icon}
                      alt={
                        language === "bn"
                          ? item.type_name_bangla
                          : item.type_name
                      }
                    />
                  ) : (
                    <FiLock size={40} color="#999" />
                  )}
                </div>
                <div className="question-info">
                  <h2>
                    {item.question_type_id} : {item.type_name} ({item.total})
                    <div style={{ height: "2px" }}></div>
                    {language === "bn" && (
                      <span
                        style={{
                          fontFamily: "var(--ff-bangla)",
                          display: "block",
                        }}
                      >
                        {item.type_name_bangla}
                      </span>
                    )}
                    <div
                      style={{
                        background: "var(--primary-color)",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        color: "#fff",
                        fontSize: "12px",
                        display: "inline-block",
                        marginTop: "6px",
                      }}
                    >
                      Number of Questions: {item.total}
                    </div>
                  </h2>
                  <div className="circular-progress">
                    <CircularProgressbar
                      value={item.percentage * 100}
                      text={`${Math.round(item.percentage * 100)}%`}
                      styles={{
                        path: { stroke: "#363350" },
                        text: {
                          fill: "#363350",
                          fontSize: "20px",
                          fontWeight: "bold",
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {selectedTypes.length > 0 && (
          <div className="submit-container">
            <button className="practice-submit-button" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Buy Premium</h2>
            <p>You need a premium account to access this content.</p>
            <button
              className="buy-button"
              onClick={() => (window.location.href = "/pricing")}
            >
              Buy Premium
            </button>
            <button
              className="close-button"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Practice;
